import {
  GridFilterItem,
  GridFilterModel,
  GridFilterOperator,
  GridSortModel,
} from '@mui/x-data-grid-pro';

import {
  ArrayOperators,
  SingleOperators,
} from 'common/src/query-params/operators';
import { DataFileStatus } from 'common/src/types/enums/DataFileStatus.enum';
import { DataFileType } from 'common/src/types/enums/DataFileType.enum';

import {
  MultipleSelectorComponent,
  SingleSelectorComponent,
} from 'portal/src/components/common/Filters/CustomCollectorComponents';

type SelectFilterOption = {
  value: string;
  label: string;
};

const FILTER_OPTION = {
  key: 'value',
  label: 'label',
  value: 'value',
};

export const uploadDefaultSort: GridSortModel = [
  { field: 'uploadTimestamp', sort: 'desc' },
];

export const uploadTypeFilterOptions = Object.values(DataFileType).map(
  (value) => ({ value, label: value }),
);

export const uploadStatusFilterOptions = Object.values(DataFileStatus).map(
  (value) => ({ value, label: value }),
);

export const getValidFilterItems = (
  filterModel: GridFilterModel = { items: [] },
) => {
  return (filterModel.items ?? []).filter(
    (item) =>
      item.value !== undefined &&
      item.value !== null &&
      (!Array.isArray(item.value) ||
        (item.value.length > 0 && item.value.every((value) => !!value))) &&
      item.value !== '',
  );
};

const buildFilterOperator = ({
  label,
  value,
  options,
  isMulti,
}: {
  label: string;
  value: ArrayOperators | SingleOperators;
  options: SelectFilterOption[];
  isMulti: boolean;
}): GridFilterOperator => ({
  label,
  value,
  getApplyFilterFn: (filterItem: GridFilterItem) => {
    return filterItem as any;
  },
  InputComponent: (isMulti
    ? MultipleSelectorComponent
    : SingleSelectorComponent) as any,
  InputComponentProps: {
    service: {
      fieldset: FILTER_OPTION,
      data: options,
    },
  } as any,
});

export const selectFilterOperators = (
  options: SelectFilterOption[],
): GridFilterOperator[] => {
  const hasMultipleOptionsEnabled = options.length > 2;

  return [
    buildFilterOperator({
      label: 'Equals',
      value: hasMultipleOptionsEnabled
        ? ArrayOperators.IN
        : SingleOperators.EQUALS,
      options,
      isMulti: hasMultipleOptionsEnabled,
    }),
  ];
};
